(function () {

    function formatPrice(cents) {

        return '$' + ((Number(cents) || 0) / 100).toFixed(2);

    }


    /*
    |--------------------------------------------------------------------------
    | Format Date For Summary
    |--------------------------------------------------------------------------
    |
    | Converts a JavaScript Date into:
    |
    | 10 September 2026
    |
    | No time
    | No GMT
    | No timezone
    |--------------------------------------------------------------------------
    */

    function formatSummaryDate(date) {

        if (!date) {

            return '—';

        }

        const parsedDate =
            date instanceof Date
                ? date
                : new Date(date);

        if (
            Number.isNaN(
                parsedDate.getTime()
            )
        ) {

            return '—';

        }

        return parsedDate.toLocaleDateString(
            'en-SG',
            {
                day: 'numeric',
                month: 'long',
                year: 'numeric'
            }
        );

    }


    window.updatePackAndMoveSummary = function (booking) {

        if (!booking) return;


        /* Property */

        const property = document.querySelector(
            '[data-summary="property-type"]'
        );

        if (property) {

            property.textContent =
                booking.property?.from &&
                booking.property?.to
                    ? `${booking.property.from} → ${booking.property.to}`
                    : '—';

        }


        /* Package */

        const packageName = document.querySelector(
            '[data-summary="package"]'
        );

        const hasPackage =
            booking.package &&
            booking.package.title;

        if (packageName) {

            packageName.textContent =
                hasPackage
                    ? booking.package.title
                    : '—';

        }


        /* Delivery Address */

        const deliveryAddress = document.querySelector(
            '[data-summary="delivery-address"]'
        );

        if (deliveryAddress) {

            const a =
                booking.delivery?.address || {};

            deliveryAddress.innerHTML = [

                a.fullName,
                a.phone,
                a.line1,
                a.line2,

                [a.unit, a.postcode]
                    .filter(Boolean)
                    .join(', '),

                a.elevator
                    ? `Elevator: ${a.elevator}`
                    : ''

            ].filter(Boolean).join('<br>') || '—';

        }


        /* Move Address */

        const collectionAddress = document.querySelector(
            '[data-summary="move-address"]'
        );

        if (collectionAddress) {

            const a =
                booking.move?.address || {};

            collectionAddress.innerHTML = [

                a.fullName,
                a.phone,
                a.line1,
                a.line2,

                [a.unit, a.postcode]
                    .filter(Boolean)
                    .join(', '),

                a.elevator
                    ? `Elevator: ${a.elevator}`
                    : ''

            ].filter(Boolean).join('<br>') || '—';

        }


        /*
        |--------------------------------------------------------------------------
        | Delivery Date
        |--------------------------------------------------------------------------
        */

        const deliveryDate = document.querySelector(
            '[data-summary="move-date"]'
        );

        if (deliveryDate) {

            deliveryDate.textContent =
                formatSummaryDate(
                    booking.delivery?.date
                );

        }


        /*
        |--------------------------------------------------------------------------
        | Move Date
        |--------------------------------------------------------------------------
        */

        const moveDate = document.querySelector(
            '[data-summary="collection-date"]'
        );

        if (moveDate) {

            moveDate.textContent =
                formatSummaryDate(
                    booking.move?.date
                );

        }


        /*
        |--------------------------------------------------------------------------
        | Container Collection Date
        |--------------------------------------------------------------------------
        */

        const containerCollectionDate =
            document.querySelector(
                '[data-summary="container-collection-date"]'
            );

        if (containerCollectionDate) {

            containerCollectionDate.textContent =
                formatSummaryDate(
                    booking.containerCollection?.date ||
                    booking.containerCollectionDate
                );

        }


        /*
        |--------------------------------------------------------------------------
        | Extended Container Rental
        |--------------------------------------------------------------------------
        */

        const extendedRental =
            document.querySelector(
                '[data-summary-extended-rental]'
            );

        const extendedRentalDivider =
            document.querySelector(
                '[data-summary-extended-rental-divider]'
            );

        const extendedRentalPrice =
            document.querySelector(
                '[data-summary-extended-rental-price]'
            );


        const extendedRentalDays =
            Number(
                booking.extendedRentalDays
            ) || 0;


        const extendedRentalRate =
            Number(
                booking.extendedRentalRate
            ) || 10;


        /*
        |--------------------------------------------------------------------------
        | Calculate Rental Charge
        |--------------------------------------------------------------------------
        */

        const extendedRentalTotal =
            extendedRentalDays *
            extendedRentalRate;


        if (
            extendedRental &&
            extendedRentalDivider &&
            extendedRentalPrice
        ) {

            if (extendedRentalDays > 0) {

                extendedRental.hidden = false;

                extendedRentalDivider.hidden = false;

                extendedRentalPrice.textContent =
                    formatPrice(
                        extendedRentalTotal * 100
                    );

            }

            else {

                extendedRental.hidden = true;

                extendedRentalDivider.hidden = true;

                extendedRentalPrice.textContent =
                    '$0.00';

            }

        }


        /*
        |--------------------------------------------------------------------------
        | Elevator Charge
        |--------------------------------------------------------------------------
        */

        const elevatorRow =
            document.querySelector(
                '[data-summary-elevator]'
            );

        const elevatorDivider =
            document.querySelector(
                '[data-summary-elevator-divider]'
            );

        const elevatorPrice =
            document.querySelector(
                '[data-summary-elevator-price]'
            );

        const elevatorTitle =
            document.querySelector(
                '[data-summary-elevator-title]'
            );


        if (
            elevatorRow &&
            elevatorDivider &&
            elevatorPrice
        ) {

            const elevator =
                booking.elevator || {};

            const hasElevator =
                elevator.required &&
                Number(elevator.rawPrice) > 0;


            if (hasElevator) {

                elevatorRow.hidden = false;

                elevatorDivider.hidden = false;

                if (elevatorTitle) {

                    elevatorTitle.textContent =
                        elevator.title ||
                        'Stair Carry Charge';

                }

                elevatorPrice.textContent =
                    elevator.displayPrice ||
                    formatPrice(
                        elevator.rawPrice
                    );

            }

            else {

                elevatorRow.hidden = true;

                elevatorDivider.hidden = true;

                elevatorPrice.textContent =
                    '$0.00';

            }

        }


        /*
        |--------------------------------------------------------------------------
        | Total
        |--------------------------------------------------------------------------
        */

        const total =
            document.querySelector(
                '[data-summary="total"]'
            );


        if (total) {

            const packagePrice =
                hasPackage
                    ? Number(
                        booking.package.price
                    ) || 0
                    : 0;


            const elevatorRawPrice =
                booking.elevator?.required
                    ? Number(
                        booking.elevator.rawPrice
                    ) || 0
                    : 0;


            const extendedRentalCents =
                extendedRentalTotal * 100;


            const finalTotal =
                packagePrice +
                elevatorRawPrice +
                extendedRentalCents;


            total.textContent =
                formatPrice(
                    finalTotal
                );

        }

    };

})();